export { Subtitle } from "./Subtitle";
export { subtitle } from "./Subtitle.styles";
